import { QuizDto } from '@routellers/types/dist/translation/quiz.dto';
import { QuozRO } from '@routellers/types/dist/translation/quiz.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = QuizDto;

type ResponseData = QuozRO;

export const quiz: ApiMethodDeclaration<ParamsData, ResponseData> = (data) => ({
    url: '/translations/quiz',
    method: 'POST',
    data,
});
